import { cn } from '../../lib/utils';

/**
 * Underline-style tab strip. Pass `tabs` as [{id, label, count?}] and current value.
 */
export default function Tabs({ tabs, value, onChange, className, variant = 'underline' }) {
  if (variant === 'pills') {
    return (
      <div className={cn('inline-flex p-1 bg-ink-100 dark:bg-ink-800 rounded-md gap-1', className)}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={cn(
              'px-3 h-8 rounded text-sm font-medium tracking-tightish transition-all',
              value === tab.id
                ? 'bg-white text-ink-900 shadow-sm dark:bg-ink-900 dark:text-ink-50'
                : 'text-ink-600 hover:text-ink-900 dark:text-ink-400 dark:hover:text-ink-100'
            )}
          >
            {tab.label}
            {tab.count != null && (
              <span className={cn(
                'ml-1.5 px-1.5 py-0.5 rounded text-2xs font-semibold',
                value === tab.id
                  ? 'bg-brand-50 text-brand-700 dark:bg-brand-900/40 dark:text-brand-300'
                  : 'bg-ink-200 text-ink-600 dark:bg-ink-700 dark:text-ink-400'
              )}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={cn('flex border-b border-ink-200 dark:border-ink-800', className)}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={cn(
            'relative px-4 h-11 inline-flex items-center gap-2 text-sm font-medium tracking-tightish transition-colors -mb-px',
            value === tab.id
              ? 'text-brand-700 border-b-2 border-brand-600 dark:text-brand-300 dark:border-brand-400'
              : 'text-ink-500 border-b-2 border-transparent hover:text-ink-800 hover:border-ink-300 dark:text-ink-400 dark:hover:text-ink-200 dark:hover:border-ink-700'
          )}
        >
          {tab.label}
          {tab.count != null && (
            <span className={cn(
              'px-1.5 py-0.5 rounded text-2xs font-semibold',
              value === tab.id
                ? 'bg-brand-50 text-brand-700 dark:bg-brand-900/40 dark:text-brand-300'
                : 'bg-ink-100 text-ink-600 dark:bg-ink-800 dark:text-ink-400'
            )}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
